import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const DELETE_DIVISION = gql`
  mutation DeleteAccountDivision($id: Int!) {
    deleteAccountDivision(id: $id)
  }
`;

export function useDeleteDivision() {
  const [deleteDivisionMutation, { loading }] = useMutation(DELETE_DIVISION);

  const deleteDivision = useCallback(
    async (id) => {
      try {
        await deleteDivisionMutation({
          variables: { id },
        });
        return { success: true };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    [deleteDivisionMutation]
  );

  return { deleteDivision, loading };
}
